import { render, staticRenderFns } from "./LiveChatMessage.vue?vue&type=template&id=7873623c&scoped=true&"
import script from "./LiveChatMessage.vue?vue&type=script&lang=js&"
export * from "./LiveChatMessage.vue?vue&type=script&lang=js&"
import style0 from "./LiveChatMessage.vue?vue&type=style&index=0&id=7873623c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7873623c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VTextField})
